<script setup lang="ts">
import type SiteTopBanner from '@store/content/entities/SiteTopBanner';

const { banner } = defineProps<{
    banner: SiteTopBanner;
}>();
const contentStore = useContentStore();
const { homepageMessagesLoading } = classToRefs(contentStore);
const { isMobile } = useSize();
const height = computed(() => {
    if (isMobile.value && banner.mobileImage) {
        return (
            (banner.mobileImage.height || 0) / (banner.mobileImage.width || 1)
        );
    } else if (banner.desktopImage) {
        return (
            (banner.desktopImage.height || 0) / (banner.desktopImage.width || 1)
        );
    }
    return 0;
});

function openUrl() {
    if (banner?.link) {
        window.open(banner.link, '_blank');
    }
}
</script>
<template>
    <div
        class="banner-container"
        :class="{
            'mobile-only': !banner.desktopImage,
            'desktop-only': !banner.mobileImage,
            'loading-skeleton': homepageMessagesLoading,
            clickable: banner.link,
        }"
        :style="{
            height: `calc(min(100vw - 32px, 1200px) * ${height})`,
        }"
        @click="openUrl"
    >
        <mr-blur-hash-image
            v-if="banner.desktopImage"
            class="desktop-only"
            :src="banner.desktopImage.src"
            :hash="banner.desktopImage.blurHash"
            image-fit="cover"
            hide-blurhash-onload
            :alt="banner.desktopImage.alt"
        />
        <mr-blur-hash-image
            v-if="banner.mobileImage"
            class="mobile-only"
            :hash="banner.mobileImage.blurHash"
            :src="banner.mobileImage.src"
            image-fit="cover"
            hide-blurhash-onload
            :alt="banner.mobileImage.alt"
        />
    </div>
</template>
<style lang="scss" scoped>
.clickable {
    cursor: pointer;
}
.banner-container {
    width: 100%;
    margin-top: 8px;
    &.loading-skeleton {
        pointer-events: none;
    }
    :deep(img) {
        width: 100%;
        border-radius: 12px;
        height: auto;
        object-fit: cover;
    }
    :deep(canvas) {
        border-radius: 12px;
    }
}
</style>
